// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 951) return "static/css/951.48fd99788df4933b20b8.lib.css";
	if (chunkId === 205) return "static/css/205.ba9264adebb2291fa267.css";
	// return url for filenames based on template
	return undefined;
};